import React, { useEffect, useRef, useState } from 'react';

const BannerScroller = () => {
  const [banners, setBanners] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await fetch('/api/VieFrontwBanner', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });

        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error('Failed to fetch banners:', error);
      }
    };

    fetchBanners();
  }, []);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -window.innerWidth, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: window.innerWidth, behavior: 'smooth' });
    }
  };

  return (
    <div className="banner-wrapper">
      <button className="banner-arrow left" onClick={scrollLeft}>
        ‹
      </button>

      <div ref={scrollRef} className="banner-container">
        {banners.map((banner, idx) => (
          <img
            key={idx}
            src={`/Uploads/${banner.URL}`}
            alt={banner.Title || `Banner ${idx + 1}`}
            className="banner-img"
          />
        ))}
      </div>

      <button className="banner-arrow right" onClick={scrollRight}>
        ›
      </button>
    </div>
  );
};

export default BannerScroller;
